import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export const useMobile = (breakpoint = "sm") => {
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down(breakpoint));
  return match;
};
